import module from 'facturacion/configuracion/module.js'
import template from './template.html'

export class FacturacionConfiguracionConceptosEditarImpuestosComponent {
  idConcepto
  onChange
  seleccionado = false
  agregando = false
  impuestos = []
  $promise = null

  constructor (FacturacionConfiguracionConceptosConceptoImpuestos) {
    this.FacturacionConfiguracionConceptosConceptoImpuestos = FacturacionConfiguracionConceptosConceptoImpuestos
  }

  $onInit () {
    this.$promise = this.FacturacionConfiguracionConceptosConceptoImpuestos.get(this.idConcepto)
      .then(({data}) => (this.impuestos = data))
  }

  agregar (data) {
    this.agregando = false
    if (!data) return
    this.impuestos.push(data)
    this.onChange({$event: {details: this.impuestos}})
    this.seleccionado = false
    this.agregando = false
  }

  eliminar (item) {
    this.impuestos.splice(this.impuestos.indexOf(item), 1)
  }
}

module.component('facturacionConfiguracionConceptosEditarImpuestos', {
  controller: FacturacionConfiguracionConceptosEditarImpuestosComponent,
  template,
  bindings: {
    idConcepto: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/components/conceptos/editar/impuestos/component.js